<template>
    <div style="background-color: #fafafa;">
		<van-nav-bar title="列表" left-text="返回" right-text="出库记录" left-arrow @click-left="onClickLeft" @click-right="onClickRight" fixed></van-nav-bar>
		<van-search class="search-box" style="margin-top: 3.2rem;" shape="round" v-model="value" placeholder="请输入搜索关键词" show-action @search="onSearch" @input="onSearch"
					@cancel="onSearch" @clear="onSearch">
			<div slot="action" @click="onSearch">搜索</div>
		</van-search>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" @load="onLoad" class="listBox" finished-text="没有更多了">
				<van-checkbox-group v-model="checkIds">
                <div v-for="(item, index) in list" class="card" :key="item.uuid" @click="selectTheOutput(index)">
					<table class="layout" style="width: 100%" >
						<tr style="width: 100%" >
							<td rowspan="2" style="width: 10%" >
								<van-checkbox :name="item.uuid" v-if="multiple" ref="checkboxes" slot="left-icon"/>
							</td>
							<td colspan="2">
								<div class="header">
									<span class="title">{{item.serialNumber}}</span>
								</div>
							</td>
						</tr>
						<tr>
							<td colspan="2" class="content">
								<p><span>经销商：</span><span>{{item.dealerIdname}}</span></p>
								<p><span>客户：</span><span>{{item.customerId}}</span></p>
								<p><span>数量：</span><span>{{item.outQuantities}}</span></p>
								<p><span>制单日期：</span><span>{{item.createTime}}</span></p>
							</td>
						</tr>
					</table>
                </div>
				</van-checkbox-group>
            </van-list>
        </van-pull-refresh>
		<div class="recordBox">
			<van-button type="info" size="large" @click="openDetail()">扫码出库</van-button>
		</div>
    </div>
</template>

<script>
    import {Tab, Tabs, Panel, Button, List, Search, Popup,PullRefresh,NavBar,Checkbox, CheckboxGroup,Toast} from 'vant';
	import barcodeService from "../../service/barcodeService";
    import {formatDictionary} from "../../utils/dictionary";
	import moment from "moment";
    export default {
        data: function () {
            return {
                list: [],
                loading: false,
                finished: false,
                pageIndex: 0,
                refreshing: false,
				value: '',
				multiple: true,
				checkIds:[]
            }
        },
      
        components: {
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Button.name]: Button,
            [PullRefresh.name]: PullRefresh,
            [Panel.name]: Panel,
            [List.name]: List,
            [Search.name]: Search,
            [Popup.name]: Popup,
			[Checkbox.name]: Checkbox,
			[CheckboxGroup.name]: CheckboxGroup,
			[NavBar.name]: NavBar,
        },
        computed: {
            
        },
        created: async function () {
            
        },
        methods: {
            async onLoad() {
                this.pageIndex++;
                let resp = await barcodeService.getOutputList(this.pageIndex, this.value);
                resp.data.Data.data.forEach(item => {
                    item.createTime = moment(item.createTime).format('YYYY-MM-DD');
                });
                formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                this.loading = false;
                this.refreshing = false;
                this.list = [...this.list, ...resp.data.Data.data];
                this.finished = resp.data.Data.total <= this.list.length;
                console.log(this.list)
            },
            onRefresh() {
                this.finished = false;
                this.loading = true;
                this.pageIndex = 0;
                this.list = [];
                this.onLoad();
            },
			onSearch() {
				this.finished = false;
				this.loading = true;
				this.pageIndex = 0;
				this.list = [];
				this.onLoad();
			},
			async openDetail(){
				if(this.checkIds.length == 0){
					Toast.fail("请选择一个出库单！");
					return;
				}
				let resp = await barcodeService.insertScanningOutput(this.checkIds.join(","));
				if (resp.data.Status === "1"){
					this.$router.push({path:"outputDetails",query:{uuid: this.checkIds.join(","), scanningOutputId: resp.data.Data}});
				} else {
					Toast.fail(resp.data.Data);
				}
            },
			selectTheOutput(index){
				this.$refs.checkboxes[index].toggle();
			},
			onClickLeft(){
				 this.$router.go(-1);
			},
			onClickRight(){
				this.$router.push("scanningOutput");
			},
        }
    };

</script>
<style>
	.listBox{
		margin-top: 0;
	}
	.card p {
		margin:10px 0;
	}
	.card p>span:first-child {
		flex: 0 0 4rem;
		text-align: right;
		margin-right: 20px;
	}
	.van-pull-refresh__head{
		display: none;
	}
	.recordBox {
		padding: 0.5rem 0;
		box-sizing: border-box;
		margin-top: 2rem;
		bottom:0;
		position:fixed;
		width: 100%;
	}
</style>